import { Button, Col, Modal, Row, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router";
import "./SuccessPaymentModal.less";
import * as moment from "moment";
import { CustIcon } from "../../Svgs";

const { Title } = Typography;

export const SuccessPaymentModal = ({ visible }) => {
  const history = useHistory();

  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      wrapClassName="paymentSuccessModelPOP"
    >
      <div className="paymentSuccessModel">
        <div className="text-center pb-3">
          <CustIcon type="success" />
        </div>
        <Title level={1} className="text-center">
          Payment Successful
        </Title>
        <div className="py-3 border-top">
          <strong className="d-block text-center">Thank you</strong>
          <span className="d-block text-center">
            your payment was successful. Check your email for your receipt.
          </span>
        </div>
        <div className="py-3 border-top">
          <Row gutter={16}>
            {/* <Col md={8} className="pb-3">
              <strong>Payment ID</strong>
            </Col>
            <Col md={16} className="text-right">
              SAMOJO6490293A3049572
            </Col> */}
            <Col md={8} className="pb-3">
              <strong>Time</strong>
            </Col>
            <Col md={16} className="text-right">
              <span>{moment().format("MMMM DD, YYYY")} at {moment().format("h:mma")}</span>
            </Col>
          </Row>
        </div>
        <div className="pt-2">
          <Button
            type="primary"
            shape="round"
            htmlType="submit"
            onClick={() => history.push("/on-boarding/location")}
            block
          >
            Done
          </Button>
        </div>
      </div>
    </Modal>
  );
};
